import { call } from 'redux-saga/effects';
import { places } from 'mz-sdk';


/**
 * By given place information from deeplink try to get exact place
 * object from the backend. Returned object is in place suggestion format.
 */
export default function* findPlaceByName(query) {
  try {
    return yield call(places.findPlace, query);
  } catch (err) {
    return { display: query, value: query };
  }
}
